interface SectionHeadingProps {
  icon: string;
  eyebrow: string;
  title: string;
  desc: string;
  tone?: 'primary' | 'accent' | 'secondary';
}

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function SectionHeading({ icon, eyebrow, title, desc, tone = 'primary' }: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center gap-2">
        <span className={`flex items-center justify-center w-8 h-8 rounded-md ${toneMap[tone]}`}>
          <i className={`${icon} text-base`}></i>
        </span>
        <span className="text-xs font-medium tracking-widest text-foreground-500">{eyebrow}</span>
      </div>
      <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
      <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">{desc}</p>
    </div>
  );
}